import { Injectable } from '@angular/core';
import { formatDate, dateToUserTimezone } from '../helpers/date-utils';
import { DateFormat } from '../shared/enums/date-formats.enum';

@Injectable({
  providedIn: 'root',
})
export class DateUtilsService {
  /**
   * Formats a date using the application's date formatting logic
   * @param dateString - The date to format
   * @param locale - The locale to use for formatting
   * @returns Formatted date string
   */
  formatDate(dateString: string | Date, locale = 'pt-BR'): string {
    return formatDate(dateString, locale);
  }

  /**
   * Converts a date to user timezone
   * @param value - The date to convert
   * @param format - The format to use
   * @param locale - The locale to use
   * @returns Date converted to user timezone as string
   */
  dateToUserTimezone(
    value: string | Date,
    format: DateFormat = DateFormat.DATETIME,
    locale = 'pt-BR'
  ): string {
    return dateToUserTimezone(value, format, locale);
  }
}
